import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { ErrorBoundary, RouteWithSubRoutes, NotFound } from '@cordata/buffet';
import PropTypes from 'prop-types';

const RouteTeller = ({
  exact: Exact,
  routes,
  root,
}) => {
  const match = useRouteMatch();

  return (
    <ErrorBoundary>
      <Switch>
        {Exact && <Route
          exact
          path={match.url}
          render={() => <Exact />}
        />}

        {routes && routes.map(r => (
          <RouteWithSubRoutes
            key={r.path}
            {...r}
            path={root ? r.path : `${match.path}/${r.path}`}
          />
        ))}

        <Route render={props => <NotFound {...props} isRoute />} />
      </Switch>
    </ErrorBoundary>

  );
};

RouteTeller.propTypes = {
  exact: PropTypes.func,
  routes: PropTypes.arrayOf(PropTypes.shape()),
  root: PropTypes.bool,
};

RouteTeller.defaultProps = {
  exact: undefined,
  routes: undefined,
  root: false,
};

export default RouteTeller;
